export default __webpack_public_path__ + "static/media/Pause.6e0eaa47.svg";